// Host contract: document.dispatchEvent(new CustomEvent("finex:beforeLeave", { cancelable: true, detail: { proceed } }))
// before a company switch or full leave; false means a dirty editor stayed, so abort. Discard calls proceed() if given.
export const LEAVE_EVENT = "finex:beforeLeave";

export type LeaveProceed = (() => void) | null;

/** Cancels the host's leave while `isDirty()` and reports it; returns the remover. */
export const installLeaveGuard = (
  target: EventTarget,
  isDirty: () => boolean,
  onBlocked: (proceed: LeaveProceed) => void,
): (() => void) => {
  const listener = (event: Event) => {
    if (!isDirty()) return;
    event.preventDefault();
    const proceed = (event as CustomEvent).detail?.proceed;
    onBlocked(typeof proceed === "function" ? () => proceed() : null);
  };
  target.addEventListener(LEAVE_EVENT, listener);
  return () => target.removeEventListener(LEAVE_EVENT, listener);
};
